import React from 'react'
import { ThemeProvider } from 'styled-components'
import { useLocation } from 'react-router-dom'
import defaultStyle from '../config/defaultStyle'
import mainConfig from '../config'

const useQuery = () => {
    return new URLSearchParams(useLocation().search)
}

const StyleProvider = ({children, gameSlug}) => {
    const query = useQuery()
    const customStyle = query.get('theme')
    let style = defaultStyle
    if(gameSlug) {
        const game = mainConfig.find(game => game.slug === gameSlug)
        if(game && game.config.hasOwnProperty('style')) {
            if(customStyle) {
                if(game.config.style.hasOwnProperty(customStyle)) Object.assign(style, game.config.style[customStyle])
            }else{
                if(game.config.style.hasOwnProperty('default')) Object.assign(style, game.config.style.default)
            }
        }
    }

    return(
        <ThemeProvider theme={style}>{children}</ThemeProvider>
    )
}

export default StyleProvider
